var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0013 12C11.0013 9.23858 13.2399 7 16.0013 7C18.7627 7 21.0013 9.23858 21.0013 12C21.0013 14.7614 18.7627 17 16.0013 17C13.2399 17 11.0013 14.7614 11.0013 12ZM16.0013 9C14.3444 9 13.0013 10.3431 13.0013 12C13.0013 13.6569 14.3444 15 16.0013 15C17.6582 15 19.0013 13.6569 19.0013 12C19.0013 10.3431 17.6582 9 16.0013 9Z",
    fill: "#388BDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27652 10.8363C7.64153 6.40804 11.342 3 15.7853 3H16.2173C20.6606 3 24.3611 6.40804 24.7261 10.8363C24.9218 13.21 24.1885 15.567 22.6809 17.4108L17.8878 23.2726C16.9128 24.465 15.0898 24.465 14.1148 23.2726L9.32173 17.4108C7.81407 15.567 7.08086 13.21 7.27652 10.8363ZM15.7853 5C12.3829 5 9.54926 7.60968 9.26976 11.0006C9.11666 12.8579 9.69037 14.7021 10.87 16.1448L15.6631 22.0066C15.8379 22.2204 16.1647 22.2204 16.3395 22.0066L21.1326 16.1448C22.3123 14.7021 22.886 12.8579 22.7329 11.0006C22.4534 7.60968 19.6197 5 16.2173 5H15.7853Z",
    fill: "#388BDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2291 21.7805C10.4761 21.2866 10.2758 20.6859 9.78185 20.4389C9.28787 20.1919 8.6872 20.3921 8.44021 20.8861L5.77354 26.2194C5.61855 26.5294 5.63511 26.8976 5.81732 27.1924C5.99953 27.4872 6.32139 27.6667 6.66797 27.6667H25.3346C25.6812 27.6667 26.0031 27.4872 26.1853 27.1924C26.3675 26.8976 26.3841 26.5294 26.2291 26.2194L23.5624 20.8861C23.3154 20.3921 22.7147 20.1919 22.2208 20.4389C21.7268 20.6859 21.5266 21.2866 21.7735 21.7805L23.7166 25.6667H8.286L10.2291 21.7805Z",
    fill: "#388BDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2a53d359f711296661cddda4b5f33cb4.svg";
export { ForwardRef as ReactComponent };